// @ts-strict-ignore
import type { Module } from 'vuex'

import type { Dictionary, HighlightsSetup, HighlightsState } from '../../models'
import type { StorageService } from '../../services'

import { CONTAINER } from '../../config'

import { TYPES } from '../../config/inversify.types'

import { SetSetupAction } from './actions/set-setup.action'
import { SetupGetter } from './getters/setup.getter'
import { HIGHLIGHTS_CONSTS } from './highlights.consts'
import { SetSetupMutation } from './mutations/set-setup.mutation'

export const HIGHLIGHTS_MODULE: Module<HighlightsState, any> = {
  namespaced: true,

  initialState: (): HighlightsState => {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    const setupValueString = storageService.getItem(HIGHLIGHTS_CONSTS.storage.setup)

    let setupJsonParsed: Dictionary<HighlightsSetup> = {}
    try {
      if (setupValueString) {
        setupJsonParsed = JSON.parse(setupValueString)
      }
    } catch (error) {
      console.error(error)
    }
    return {
      setup: setupJsonParsed,
    }
  },
  state: (): HighlightsState => HIGHLIGHTS_MODULE.initialState(),

  getters: {
    [HIGHLIGHTS_CONSTS.getters.setup]: SetupGetter.execute,
  },

  actions: {
    [HIGHLIGHTS_CONSTS.actions.setSetup]: SetSetupAction.execute,
  },

  mutations: {
    [HIGHLIGHTS_CONSTS.mutations.setSetup]: SetSetupMutation.execute,
  },
}
